import ApiHandler from "src/api/ApiHandler"
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import StateConstants from "src/states/StateContstants"

/** The "What stopped you?" survey asked when a visitor closes the plans pop up without paying, stored in our survey_responses table. */
export const PLAN_DISMISS_SURVEY_TYPE = "plans_dismissed"

export const REASON_QUESTION = "What stopped you?"
export const COMPETITOR_QUESTION = "Which one?"
export const ANOTHER_SITE = "I went with another site"
export const SOMETHING_ELSE = "Something else"

/** In the order shown. */
export const REASON_CHOICES = [
    "Too expensive",
    "Didn't want a subscription",
    "The free estimate was enough",
    "Not sure I can trust it",
    ANOTHER_SITE,
    "Just looking",
    SOMETHING_ELSE,
]

const SHOWN_KEY = "planDismissSurveyShown"

/** What the visitor was looking at, sent with every survey event. Never personal data. */
export interface PlanDismissSurveyContext {
    surface: "modal" | "page"
    plan: string | null
    property_id: string | null
}

function hasBeenShown(): boolean {
    try {
        return localStorage.getItem(SHOWN_KEY) === "true"
    } catch {
        return true
    }
}

function markShown() {
    try {
        localStorage.setItem(SHOWN_KEY, "true")
    } catch {
        // Without storage it may show again on another visit, which is fine.
    }
}

export function shouldShowPlanDismissSurvey(stateHandler: EventAdaptingStateHandler): boolean {
    return !stateHandler.get(StateConstants.IS_PREMIUM) && !hasBeenShown()
}

export function markPlanDismissSurveyShown() {
    markShown()
}

/** Best effort: the visitor has already moved on, so a failed save is only logged. */
export async function submitPlanDismissSurvey(
    apiHandler: ApiHandler,
    context: PlanDismissSurveyContext,
    reason: string,
    detail: string | null,
) {
    try {
        await apiHandler.submitSurveyResponse(PLAN_DISMISS_SURVEY_TYPE, { reason, detail, ...context })
    } catch (error) {
        console.error("Failed to save the survey response", error)
    }
}
